/*
 * GENERATED by bin/build-shopify-chrome.sh from theme/synonym/js/main.js
 * Do not edit here — edit the WordPress script and re-run the build.
 * Built 2026-09-15 05:58 UTC
 */

const SYNONYM_DATA = window.synonymData || {};
function assetUrl(path) {
  return SYNONYM_DATA.assetsUrl ? `${SYNONYM_DATA.assetsUrl}/${path}` : `assets/${path}`;
}
const menuToggle = document.querySelector('.menu-toggle');
document.querySelectorAll('.back-to-top').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  });
});
const GOO_BLOB_RADII = [9, 7, 5, 4]; // tapering chain, leader to tail
const GOO_BLOB_EASE = [0.3, 0.22, 0.16, 0.11]; // lower = more lag behind the one ahead of it
const GOO_RADIUS_EASE = 0.18;
const GOO_ACTIVE_MARGIN = 110; // px around the wordmark where the trail is "live"
const PICKUP_RADIUS = 30; // svg units — how close the leader needs to be to pick up a dot
const PICKUP_GROW_EASE = 0.35; // fast: a dot melts into the trail quickly
const PICKUP_SHRINK_EASE = 0.05; // slow: it lingers/melts back down gradually
function createCursorTrail(svg, layer, { radii, blobClass, margin, onFrame }) {
  const NS = 'http://www.w3.org/2000/svg';
  const blobs = [];

  for (let i = 0; i < radii.length; i++) {
    const circle = document.createElementNS(NS, 'circle');
    circle.setAttribute('r', '0');
    circle.classList.add(blobClass);
    layer.appendChild(circle);
    blobs.push({ el: circle, x: 0, y: 0, r: 0 });
  }

  let mouseX = null;
  let mouseY = null;
  let rafId = null;

  function toSvgPoint(clientX, clientY) {
    const ctm = svg.getScreenCTM();
    if (!ctm) return { x: 0, y: 0 };
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    const sp = pt.matrixTransform(ctm.inverse());
    return { x: sp.x, y: sp.y };
  }

  function tick() {
    rafId = null;
    if (mouseX === null) return;

    const svgRect = svg.getBoundingClientRect();
    const withinRange =
      mouseX > svgRect.left - margin && mouseX < svgRect.right + margin &&
      mouseY > svgRect.top - margin && mouseY < svgRect.bottom + margin;

    const target = toSvgPoint(mouseX, mouseY);
    let leaderX = target.x;
    let leaderY = target.y;
    let settled = true;

    blobs.forEach((b, i) => {
      b.x += (leaderX - b.x) * GOO_BLOB_EASE[i];
      b.y += (leaderY - b.y) * GOO_BLOB_EASE[i];
      const targetR = withinRange ? radii[i] : 0;
      b.r += (targetR - b.r) * GOO_RADIUS_EASE;

      if (Math.abs(b.r - targetR) > 0.3 || Math.hypot(leaderX - b.x, leaderY - b.y) > 0.3) {
        settled = false;
      }

      b.el.setAttribute('cx', b.x.toFixed(2));
      b.el.setAttribute('cy', b.y.toFixed(2));
      b.el.setAttribute('r', Math.max(b.r, 0).toFixed(2));

      leaderX = b.x;
      leaderY = b.y;
    });

    // The chain's leader is the point everything else is measured from.
    if (onFrame && onFrame(blobs[0].x, blobs[0].y, withinRange)) settled = false;

    if (!settled) rafId = requestAnimationFrame(tick);
  }

  window.addEventListener('pointermove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!rafId) rafId = requestAnimationFrame(tick);
  }, { passive: true });

  window.addEventListener('scroll', () => {
    if (mouseX !== null && !rafId) rafId = requestAnimationFrame(tick);
  }, { passive: true });
}
function initMetaballTrail(svg, dots) {
  const NS = 'http://www.w3.org/2000/svg';

  const defs = document.createElementNS(NS, 'defs');
  defs.innerHTML = `
    <filter id="wordmark-goo" x="-200%" y="-200%" width="500%" height="500%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
      <feColorMatrix in="blur" mode="matrix"
        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 16 -6.5" result="goo" />
    </filter>`;
  svg.insertBefore(defs, svg.firstChild);

  const gooLayer = document.createElementNS(NS, 'g');
  gooLayer.classList.add('wordmark-goo-group');
  svg.appendChild(gooLayer);

  // Static per-dot metadata (position/size never changes — only r does),
  // plus a proxy circle on the goo layer standing in for each dot while
  // it's "picked up".
  const dotMeta = dots.map((dot) => {
    const bbox = dot.getBBox();
    const proxy = document.createElementNS(NS, 'circle');
    proxy.setAttribute('r', '0');
    proxy.setAttribute('cx', (bbox.x + bbox.width / 2).toFixed(2));
    proxy.setAttribute('cy', (bbox.y + bbox.height / 2).toFixed(2));
    proxy.classList.add('wordmark-blob');
    gooLayer.appendChild(proxy);
    return {
      proxy,
      cx: bbox.x + bbox.width / 2,
      cy: bbox.y + bbox.height / 2,
      naturalR: Math.max(bbox.width, bbox.height) / 2,
      r: 0,
    };
  });

  // The trail leader is the pickup point for nearby dots: any dot it comes close
  // to grows its proxy on the goo layer and melts into the chain.
  createCursorTrail(svg, gooLayer, {
    radii: GOO_BLOB_RADII,
    blobClass: 'wordmark-blob',
    margin: GOO_ACTIVE_MARGIN,
    onFrame(pickX, pickY, withinRange) {
      let working = false;

      dotMeta.forEach((entry) => {
        const near = withinRange && Math.hypot(entry.cx - pickX, entry.cy - pickY) < PICKUP_RADIUS;
        const targetR = near ? entry.naturalR : 0;
        const ease = targetR > entry.r ? PICKUP_GROW_EASE : PICKUP_SHRINK_EASE;
        const nextR = entry.r + (targetR - entry.r) * ease;

        if (Math.abs(nextR - entry.r) > 0.02 || entry.r > 0.02) {
          entry.r = nextR < 0.02 ? 0 : nextR;
          entry.proxy.setAttribute('r', entry.r.toFixed(2));
          working = true;
        }
      });

      return working;
    },
  });
}
async function initWordmark() {
  const container = document.querySelector('.wordmark');
  if (!container) return;

  const fallbackImg = container.querySelector('.wordmark-fallback');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  try {
    const response = await fetch(SYNONYM_DATA.wordmarkSvg || assetUrl('img/synonym-mag-wordmark.svg'));
    if (!response.ok) throw new Error(`Failed to fetch wordmark SVG: ${response.status}`);

    const svgText = await response.text();
    const parsed = new DOMParser().parseFromString(svgText, 'image/svg+xml');
    const svg = parsed.querySelector('svg');
    if (!svg || parsed.querySelector('parsererror')) throw new Error('Could not parse wordmark SVG');

    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.classList.add('wordmark-svg');

    const dots = [];

    svg.querySelectorAll('path').forEach((letterPath) => {
      const d = letterPath.getAttribute('d') || '';
      const fill = letterPath.getAttribute('fill');
      // Each letter is one compound path made of many closed "M...Z" dot
      // shapes concatenated together — split it back into individual dots.
      const subpaths = d.split(/(?=M)/).map((s) => s.trim()).filter(Boolean);

      const frag = document.createDocumentFragment();
      subpaths.forEach((sub) => {
        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        dot.setAttribute('d', sub);
        if (fill) dot.setAttribute('fill', fill);
        dot.classList.add('wordmark-dot');
        frag.appendChild(dot);
        dots.push(dot);
      });

      letterPath.replaceWith(frag);
    });

    if (fallbackImg) fallbackImg.remove();
    container.appendChild(svg);

    if (!prefersReducedMotion) {
      initMetaballTrail(svg, dots);
    }
  } catch (err) {
    // Inline SVG unavailable (e.g. opened via file:// with no server) —
    // the fallback <img> in the markup stays visible as-is.
  }

  recalcNavMetrics();
}
const FOOTER_GOO_BLOB_RADII = [3.2, 2.5, 1.8, 1.4]; // svg units, and the mark is drawn 1:1
const FOOTER_GOO_ACTIVE_MARGIN = 60; // px around the logo where the trail is "live"
async function initFooterLogo() {
  const container = document.querySelector('.footer-logo-link');
  if (!container) return;

  const fallbackImg = container.querySelector('.footer-logo');
  if (!fallbackImg) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  try {
    const response = await fetch(SYNONYM_DATA.footerLogoSvg || assetUrl('img/synonym-logo-footer.svg'));
    if (!response.ok) throw new Error(`Failed to fetch footer logo: ${response.status}`);

    const parsed = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
    const svg = parsed.querySelector('svg');
    if (!svg || parsed.querySelector('parsererror')) throw new Error('Could not parse footer logo');

    const NS = 'http://www.w3.org/2000/svg';

    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.removeAttribute('style');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('footer-logo', 'footer-logo-svg');

    /*
     * The filter region has to reach well outside the mark: the blob is live up
     * to 60px away from it, and a filter clipped to the default -10%/120% box
     * would cut it off mid-air on the way in.
     */
    const defs = document.createElementNS(NS, 'defs');
    defs.innerHTML = `
      <filter id="footer-logo-goo" x="-200%" y="-200%" width="500%" height="500%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.3" result="blur" />
        <feColorMatrix in="blur" mode="matrix"
          values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 16 -6.5" result="goo" />
      </filter>`;

    // Everything that was drawing the logo moves onto the filtered layer, and the
    // trail joins it there. One layer, so the two fuse; one ink, as everywhere else.
    const gooLayer = document.createElementNS(NS, 'g');
    gooLayer.classList.add('footer-logo-goo-group');
    while (svg.firstChild) gooLayer.appendChild(svg.firstChild);

    svg.appendChild(defs);
    svg.appendChild(gooLayer);

    fallbackImg.replaceWith(svg);

    createCursorTrail(svg, gooLayer, {
      radii: FOOTER_GOO_BLOB_RADII,
      blobClass: 'footer-logo-blob',
      margin: FOOTER_GOO_ACTIVE_MARGIN,
    });
  } catch (err) {
    // Left as the plain <img> it already was.
  }
}
const wordmark = document.querySelector('.wordmark');
const primaryNav = document.querySelector('.primary-nav');
const navSpacer = document.querySelector('.nav-spacer');
const WORDMARK_PARALLAX_RATE = -0.12;
const NAV_PARALLAX_RATE = -0.18;
const PEEK_OFFSET = 80;
const REVEAL_OFFSET = 24;
const CLOSE_ZONE = 160; // px of scroll, right at the top, where the bar's
const HEADER_HOVER_ZONE = 160; // px from the top of the viewport — same hover
let spacerHeight = 0;
let naturalNavTop = 0;
let lastScrollY = window.scrollY;
let scrollTicking = false;
let headerHovering = false;
let scrolledUp = false;
let navDropdownOpen = false;
let refreshNavReveal = () => {};
function setNavDropdownOpen(open) {
  if (open === navDropdownOpen) return;
  navDropdownOpen = open;
  refreshNavReveal();
}
function recalcNavMetrics() {
  if (!primaryNav || !navSpacer) return;

  const wasPinned = primaryNav.classList.contains('is-pinned');
  if (wasPinned) {
    primaryNav.classList.remove('is-pinned', 'is-revealed', 'is-closing');
    primaryNav.style.transform = '';
  }

  const navRect = primaryNav.getBoundingClientRect();
  const navStyles = getComputedStyle(primaryNav);
  spacerHeight = navRect.height + parseFloat(navStyles.marginTop) + parseFloat(navStyles.marginBottom);
  // Its resting viewport position once scrollY is back to 0 — the target
  // the pinned bar animates toward as it closes.
  naturalNavTop = navRect.top + window.scrollY;

  if (wasPinned) {
    primaryNav.classList.add('is-pinned');
    navSpacer.style.height = `${spacerHeight}px`;
  }
}
function updateHeaderOnScroll() {
  const y = Math.max(window.scrollY, 0);
  if (y !== lastScrollY) {
    scrolledUp = y < lastScrollY;
  }
  if (wordmark) {
    wordmark.style.transform = `translateY(${y * WORDMARK_PARALLAX_RATE}px)`;
  }

  if (primaryNav && navSpacer && menuToggle) {
    if (y <= 0) {
      primaryNav.classList.remove('is-pinned', 'is-revealed', 'is-closing');
      primaryNav.style.transform = '';
      navSpacer.style.height = '0px';
    } else if (primaryNav.classList.contains('is-pinned')) {
      if (scrolledUp && y <= CLOSE_ZONE && !headerHovering && !navDropdownOpen) {
        // Closing zone: tie the bar's position directly to scroll so it
        // eases back to its natural spot in lockstep with the wordmark
        // scrolling back into view above it.
        const t = y / CLOSE_ZONE;
        const closingY = naturalNavTop + (REVEAL_OFFSET - naturalNavTop) * t;
        primaryNav.classList.add('is-revealed', 'is-closing');
        primaryNav.style.transform = `translateY(${closingY}px)`;
      } else {
        primaryNav.classList.remove('is-closing');
        primaryNav.style.transform = '';
        primaryNav.classList.toggle('is-revealed', scrolledUp || headerHovering || navDropdownOpen);
      }
    } else {
      // Still in normal flow — apply the parallax drift, then check the
      // icon's actual rendered position (transform included) against the
      // -80px peek threshold, rather than a precomputed scrollY value that
      // can't account for the parallax rate compounding with scroll.
      primaryNav.style.transform = `translateY(${y * NAV_PARALLAX_RATE}px)`;
      if (menuToggle.getBoundingClientRect().top <= -PEEK_OFFSET) {
        primaryNav.classList.add('is-pinned');
        primaryNav.style.transform = '';
        navSpacer.style.height = `${spacerHeight}px`;
        primaryNav.classList.toggle('is-revealed', scrolledUp || headerHovering || navDropdownOpen);
      }
    }
  }

  lastScrollY = y;
  scrollTicking = false;
}
const STORY_HOVER_ZONE = 160; // px from the top of the viewport
function initStoryNav() {
  if (!primaryNav) return;

  let lastY = window.scrollY;
  let hovering = false;
  let ticking = false;

  function applyState() {
    const y = window.scrollY;
    const scrollingUp = y < lastY;
    // At the very top, always settle back to peeking (like on page load)
    // regardless of scroll direction — only hovering keeps it revealed there.
    const revealed = hovering || navDropdownOpen || (scrollingUp && y > 0);
    primaryNav.classList.toggle('is-revealed', revealed);
    document.body.classList.toggle('nav-revealed', revealed);
    lastY = y;
    ticking = false;
  }

  refreshNavReveal = applyState;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(applyState);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('pointermove', (e) => {
    const nowHovering = e.clientY < STORY_HOVER_ZONE;
    if (nowHovering !== hovering) {
      hovering = nowHovering;
      applyState();
    }
  }, { passive: true });
}
const HERO_INTRO_CONTENT_DELAY = 500; // ms the text waits before starting
const REVEAL_AFTER_INTRO = HERO_INTRO_CONTENT_DELAY + 400;
const REVEAL_MIN_VISIBLE = 160;
const REVEAL_STORY_TEXT = [
  '.story-lead', '.story-heading', '.story-copy p', '.story-byline p', '.story-caption',
  '.story-hero-caption',
  '.story-caption--plain', '.story-image-half__caption', '.story-pullquote p',
  '.story-subject__label', '.story-subject__name', '.story-subject__credit',
  '.story-promo__title', '.story-promo__body p',
  '.story-recipe__title', '.story-recipe__serves', '.story-recipe__intro p',
  '.story-recipe__ingredients',
  '.story-recipe__method p', '.story-recipe__method .story-recipe__subhead',
  '.story-up-next__label', '.story-up-next__title',
].join(', ');
const REVEAL_DEFAULT_TEXT = [
  'h1', 'h2', 'h3', 'h4',
  'p', 'li', 'blockquote', 'figcaption', 'dd', 'dt',
].join(', ');
function initScrollReveal() {
  /* Two kinds of container: the story flow, and anything that has opted in.
     A page can have both, and a page with neither gets nothing — which is the
     old behaviour for everything that hasn't been given the class. */
  const scopes = [
    ...document.querySelectorAll('.story-content-flow'),
    ...document.querySelectorAll('.reveal-flow'),
  ];

  if (!scopes.length) return;

  const textEls = [];
  const imageEls = [];

  scopes.forEach((scope) => {
    const isStory = scope.classList.contains('story-content-flow');

    textEls.push(...scope.querySelectorAll(isStory ? REVEAL_STORY_TEXT : REVEAL_DEFAULT_TEXT));

    // Videos reveal on the same blur-in as photographs — it's the poster
    // frame coming into view either way.
    imageEls.push(...[...scope.querySelectorAll('img, .story-video__player')].filter(
      (img) => !img.closest('.story-buy-issue') && !img.classList.contains('story-up-next__image')
    ));

    /* The escape hatch, for the things element names can't reach: a drawn shape,
       a coloured panel, a div standing in for a picture that isn't there. Mark
       it data-reveal="image" or "text" and it joins the pass. */
    textEls.push(...scope.querySelectorAll('[data-reveal="text"]'));
    imageEls.push(...scope.querySelectorAll('[data-reveal="image"]'));
  });

  // A page with nested scopes, or an opted-in element that also matches by name,
  // would otherwise be collected twice.
  const text = [...new Set(textEls)];
  const images = [...new Set(imageEls)].filter((el) => !text.includes(el));

  text.forEach((el) => el.classList.add('reveal-text'));
  images.forEach((el) => el.classList.add('reveal-image'));

  const allEls = text.concat(images);

  if (!allEls.length) return;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    allEls.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  // The observer's first callback is the initial pass — everything already
  // in view when the page loaded. Every callback after it is the result of
  // scrolling, which should reveal on contact with no delay at all.
  let initialPass = true;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      /* Two ways to qualify. The ratio is the right measure for the ordinary
         run of things — a paragraph, a photograph on the measure — where 15% is
         a modest strip of the element. It stops being the right measure for
         something very tall sitting near the top of the page: 15% of a 16:9
         video is 84px of a 561px block, and on a short window there isn't that
         much screen left below it, so the block sat there unrevealed until the
         reader scrolled. A plain depth of visible pixels qualifies as well,
         which covers that case and changes nothing for anything smaller. */
      if (entry.intersectionRatio < 0.15 && entry.intersectionRect.height < REVEAL_MIN_VISIBLE) return;

      // Held back by delaying the class rather than by setting a
      // transition-delay: the element simply waits at its pre-reveal state
      // and then runs the ordinary transition, leaving no inline style to
      // clear afterwards and nothing to go wrong mid-transition.
      if (initialPass) {
        setTimeout(() => entry.target.classList.add('is-revealed'), REVEAL_AFTER_INTRO);
      } else {
        entry.target.classList.add('is-revealed');
      }
      observer.unobserve(entry.target);
    });
    initialPass = false;
  }, { threshold: [0, 0.15], rootMargin: '0px 0px -10% 0px' });

  allEls.forEach((el) => observer.observe(el));
}
const MENU_QUERY = '(max-width: 900px)';
const MENU_FADE = 250; // ms — keep in step with .site-menu's opacity transition
function initNavDropdowns() {
  const parents = [...document.querySelectorAll('.nav-list .menu-item-has-children')];
  if (!parents.length) return;

  // Below the breakpoint the bar's links are display:none and the same items
  // are printed in .site-menu with their children already showing, so there is
  // nothing here to open.
  const isMobile = window.matchMedia(MENU_QUERY);

  const items = parents
    .map((parent) => ({ parent, toggle: parent.querySelector(':scope > a') }))
    .filter((item) => item.toggle && item.parent.querySelector(':scope > .sub-menu'));

  if (!items.length) return;

  /*
   * Hands the open/closed state to this function. Until it's set, CSS opens a
   * panel whenever anything inside it has focus, which is what makes the
   * children reachable with no JS at all — but focus stays on the parent after
   * a click, so leaving it on would hold the panel open against the click that
   * just closed it.
   */
  items.forEach((item) => item.parent.closest('.nav-list').classList.add('is-scripted'));

  /* Tells the bar whether anything is open, so it can hold itself revealed for
     as long as there is a panel hanging off it. Called after every change to
     .is-open rather than at each call site individually — there are five ways in
     here for a panel to close, and the bar has to hear about all of them. */
  function syncNavHold() {
    const open = items.find((item) => item.parent.classList.contains('is-open'));
    setNavVeilReach(open);
    setNavDropdownOpen(Boolean(open));
  }

  /* Tells .nav-veil how far down it has to reach, which it needs because the
     panel has no background of its own — the band is what the options are read
     against, and the menu is editable, so its depth can't be a constant.

     Measured through the offsetParent chain (panel inside its li, li inside the
     bar) plus the revealed bar's offset, rather than off getBoundingClientRect:
     a panel opened from the peeking state is measured while the bar is still
     sliding down, and its viewport position at that moment is wherever the
     transition has got to. */
  function setNavVeilReach(item) {
    if (!item) {
      document.documentElement.style.removeProperty('--nav-veil-reach');
      return;
    }

    const panel = item.parent.querySelector(':scope > .sub-menu');
    const reach = REVEAL_OFFSET + item.parent.offsetTop + panel.offsetTop + panel.offsetHeight;
    document.documentElement.style.setProperty('--nav-veil-reach', `${reach}px`);
  }

  function close(item) {
    item.parent.classList.remove('is-open');
    item.toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    items.forEach((item) => {
      if (item !== except) close(item);
    });
    syncNavHold();
  }

  items.forEach((item) => {
    item.toggle.setAttribute('aria-haspopup', 'true');
    item.toggle.setAttribute('aria-expanded', 'false');

    item.toggle.addEventListener('click', (e) => {
      if (isMobile.matches) return;
      // A modified click is somebody opening the parent's own page in a tab,
      // which is what the href is still there for.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

      e.preventDefault();
      const open = item.parent.classList.contains('is-open');
      closeAll(item);

      item.parent.classList.toggle('is-open', !open);
      item.toggle.setAttribute('aria-expanded', String(!open));
      syncNavHold();
    });
  });

  // Anywhere outside the open panel closes it — including on another nav link,
  // which is a click that is about to navigate anyway.
  document.addEventListener('click', (e) => {
    if (e.target.closest('.nav-list .menu-item-has-children')) return;
    closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const open = items.find((item) => item.parent.classList.contains('is-open'));
    if (!open) return;

    close(open);
    syncNavHold();
    // Back to the control that opened it, rather than leaving focus inside a
    // panel that is no longer on screen.
    open.toggle.focus();
  });

  /*
   * Scrolling closes it, and this is the half of the rule that lets the bar
   * retract again: while a panel is open the bar holds itself revealed (see
   * navDropdownOpen), so scroll is what releases both at once — the panel goes,
   * the hold goes with it, and the bar peeks away on the same gesture instead of
   * leaving a menu floating over the page attached to nothing.
   *
   * Deliberately any scroll, not just a scroll far enough to hide the bar: a
   * reader who has started moving the page has stopped reading the menu.
   *
   * Guarded so an ordinary scroll with nothing open doesn't touch the DOM on
   * every frame.
   */
  window.addEventListener('scroll', () => {
    if (items.some((item) => item.parent.classList.contains('is-open'))) closeAll();
  }, { passive: true });

  // Crossing the breakpoint puts the panel's own copy of these links on screen;
  // an open dropdown in a bar that is now display:none would be left behind.
  isMobile.addEventListener('change', () => closeAll());
}
function initSiteMenu() {
  const panel = document.getElementById('site-menu');
  if (!panel || !menuToggle) return;

  const closeButton = panel.querySelector('.site-menu__close');
  const isMobile = window.matchMedia(MENU_QUERY);
  // The icon is a link home on desktop and a dialog trigger below the
  // breakpoint, so its name has to change with its job — announcing "Synonym
  // home, collapsed, button" at a control that opens the menu is worse than
  // no label. The link's own label is kept to put back on the way out.
  const homeLabel = menuToggle.getAttribute('aria-label') || '';
  const menuLabel = menuToggle.dataset.menuLabel || homeLabel;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let hideTimer = null;
  let lastFocused = null;

  // Announced as a disclosure only while the panel is actually reachable —
  // above the breakpoint the same element is nothing but a link home.
  function setDisclosure(on) {
    if (on) {
      menuToggle.setAttribute('aria-haspopup', 'dialog');
      menuToggle.setAttribute('aria-expanded', 'false');
      if (menuLabel) menuToggle.setAttribute('aria-label', menuLabel);
    } else {
      menuToggle.removeAttribute('aria-haspopup');
      menuToggle.removeAttribute('aria-expanded');
      if (homeLabel) menuToggle.setAttribute('aria-label', homeLabel);
    }
  }

  // Opened by a tap or a click, rather than by the keyboard. The cross still
  // takes focus either way — the panel is modal, and focus has to be inside it —
  // but a reader who tapped the icon has no use for a ring around the control
  // they just touched, and engines disagree about whether a scripted .focus()
  // counts as :focus-visible. The panel says which it was and the CSS decides.
  function openMenu(byPointer = false) {
    lastFocused = document.activeElement;
    clearTimeout(hideTimer);
    panel.hidden = false;
    document.body.classList.add('menu-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    // Next frame, so the panel has been laid out at opacity 0 and the
    // transition has somewhere to run from instead of snapping on.
    requestAnimationFrame(() => panel.classList.add('is-open'));
    panel.classList.toggle('is-pointer-open', byPointer);
    if (closeButton) closeButton.focus();
  }

  function closeMenu({ restoreFocus = true } = {}) {
    if (panel.hidden) return;
    panel.classList.remove('is-open', 'is-pointer-open');
    document.body.classList.remove('menu-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    // Held open until the fade finishes — hiding it immediately would cut the
    // transition off on its first frame.
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      panel.hidden = true;
    }, prefersReducedMotion ? 0 : MENU_FADE);
    if (restoreFocus && lastFocused) lastFocused.focus();
  }

  menuToggle.addEventListener('click', (e) => {
    if (!isMobile.matches) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    // detail is the click count: 0 is Enter or Space on the link, anything
    // above it is a real pointer.
    openMenu(e.detail !== 0);
  });

  if (closeButton) closeButton.addEventListener('click', () => closeMenu());

  // Any link in the panel is a destination, so the panel's job is done — this
  // matters for the in-page ones, which wouldn't reload and would otherwise
  // leave the reader looking at the menu instead of the anchor they picked.
  panel.addEventListener('click', (e) => {
    if (e.target.closest('a')) closeMenu({ restoreFocus: false });
  });

  document.addEventListener('keydown', (e) => {
    if (panel.hidden) return;
    if (e.key === 'Escape') {
      closeMenu();
      return;
    }
    // The panel claims aria-modal, so tabbing has to stay inside it.
    if (e.key !== 'Tab') return;
    // Reaching for Tab is the moment the ring stops being noise, whatever
    // opened the panel.
    panel.classList.remove('is-pointer-open');
    const focusable = panel.querySelectorAll('a[href], button');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Rotating to landscape or resizing past the breakpoint puts the bar's own
  // links back, which would leave the panel covering a page that no longer
  // needs it.
  isMobile.addEventListener('change', (e) => {
    if (e.matches) {
      setDisclosure(true);
    } else {
      // Close first: closeMenu() sets aria-expanded, so clearing the
      // disclosure attributes before it would only have them put back.
      closeMenu();
      setDisclosure(false);
    }
  });

  if (isMobile.matches) setDisclosure(true);
}

/*
 * Which header this page is wearing is a question the markup already answers:
 * the section renders .site-header only for the in-flow arrangement, and the
 * bare pinned nav otherwise. Branching on that rather than on a template name
 * keeps the decision in the Liquid instead of split across two files that could
 * disagree.
 *
 * The magazine branches the same way, on body.story-page. It can't here: the
 * <body> tag belongs to Rise's layout, and a section has no way to add a class
 * to it.
 */
if (document.querySelector('.site-header')) {
  /*
   * In-flow header with the wordmark above it: parallax on the way down, pin
   * once the menu icon would pass -80px, release at the very top.
   *
   * The inlining is for the cursor, and only for the cursor. initWordmark()
   * fetches the mark, splits each letter's compound path into its 237 separate
   * dots and hands them to the metaball trail — which needs a pointer to
   * follow. Without one there is nothing to drive it, and the 478-node SVG it
   * builds is a slower way to draw the same picture the <img> in the markup is
   * already drawing.
   *
   * It also stops the mark vanishing on iPhone. Reported 2026-09-15: on iOS
   * Safari the shop's wordmark flashes and then goes, and does not come back on
   * scroll — the <img> paints, the swap lands, and what replaces it draws
   * nothing. The same inlined SVG on synonym-mag.com is fine on the same phone,
   * and the two DOMs are identical down to the filter, so it is something about
   * the surrounding page rather than the mark; the header sits in flow inside a
   * grid body here and absolutely positioned over the hero there. Not diagnosed
   * — there is no WebKit on this machine to step through — but not guessed at
   * either: the branch below is the behaviour that was wanted anyway, and it
   * leaves the phone on the <img>, which Joel confirms renders.
   *
   * recalcNavMetrics() is the one thing initWordmark() does that is not about
   * the trail, and the bar's pin maths needs it either way.
   */
  if (window.matchMedia('(pointer: fine)').matches) {
    initWordmark();
  } else {
    recalcNavMetrics();
  }

  refreshNavReveal = updateHeaderOnScroll;

  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      requestAnimationFrame(updateHeaderOnScroll);
      scrollTicking = true;
    }
  }, { passive: true });

  window.addEventListener('pointermove', (e) => {
    const nowHovering = e.clientY < HEADER_HOVER_ZONE;
    if (nowHovering !== headerHovering) {
      headerHovering = nowHovering;
      updateHeaderOnScroll();
    }
  }, { passive: true });

  window.addEventListener('resize', recalcNavMetrics);
  window.addEventListener('load', recalcNavMetrics);
  recalcNavMetrics();
} else {
  initStoryNav();
}

initSiteMenu();
initNavDropdowns();

/*
 * The load-in: type fades and drifts up, pictures blur in, as each comes into
 * view. Any container marked .reveal-flow opts in — the shop puts that on its
 * grid, the product page and the callouts.
 *
 * Then .is-priming comes off. The flag is set by an inline script in the head
 * (see layout/theme.liquid) so the stylesheet can hide those containers before
 * the first paint, rather than letting them paint finished and be yanked back
 * the moment this file arrives. Dropping it here — after the starting states
 * are set, and not a line earlier — is what makes the two halves meet.
 */
initScrollReveal();
document.documentElement.classList.remove('is-priming');

/*
 * You May Also Like arrives after the page does.
 *
 * <product-recommendations> fetches its own contents and swaps them in, so the
 * pass above ran while that row was still an empty shell — the row carries
 * .reveal-flow, and there was nothing inside it to collect. Everything else on
 * the page revealed and it alone stayed plain, which is the kind of gap that
 * only shows on one template.
 *
 * initScrollReveal() re-collects from scratch, so calling it again is enough:
 * anything already revealed keeps the class it has and is simply re-observed,
 * and the new row joins the pass. Once, then the observer lets go.
 */
const productRecs = document.querySelector('product-recommendations');
if (productRecs && 'MutationObserver' in window) {
  const recsWatcher = new MutationObserver(() => {
    if (!productRecs.querySelector('img')) return;
    recsWatcher.disconnect();
    initScrollReveal();
  });
  recsWatcher.observe(productRecs, { childList: true, subtree: true });
}

// The footer is on every page, so its logo is claimed outside the header
// branch. It inlines the mark and gives it the same cursor trail the wordmark
// has, and it bails on its own under prefers-reduced-motion.
// Same reasoning as the wordmark above: it inlines the mark only to give it a
// cursor trail, so on a touch device it is work with no payoff and the same
// unexplained iOS blank to risk. The <img> in the markup is the logo there.
if (window.matchMedia('(pointer: fine)').matches) {
  initFooterLogo();
}

/*
 * Hold the bar out while the nav is being used.
 *
 * The magazine already has the mechanism: navDropdownOpen, set by
 * initNavDropdowns(), stops the bar retracting while one of its own dropdowns is
 * open. Two things it does not cover here.
 *
 * The country picker is Rise's control, so initNavDropdowns() never sees it —
 * the flag follows the button's own aria-expanded instead, which
 * localization-form.js is already maintaining.
 *
 * And the bar reveals on a cursor within 160px of the top, which is the bar
 * itself and little else. Moving down to a control in it, or into a panel it has
 * opened, could leave that band and retract the bar mid-reach. So the pointer
 * being anywhere over the nav holds it too. pointerenter/leave are subtree
 * events, and every panel is a DOM descendant of .primary-nav, so moving into an
 * open dropdown never reads as leaving.
 */
(function holdBarWhileNavIsInUse() {
  const nav = document.querySelector('.primary-nav');
  if (!nav || typeof setNavDropdownOpen !== 'function') return;

  const form = document.querySelector('.nav-localization localization-form');
  const trigger = form && form.querySelector('.disclosure__button');
  const panel = form && form.querySelector('.disclosure__list-wrapper');
  const item = form && form.closest('.nav-localization');
  let pointerInside = false;

  const navDropdownIsOpen = () =>
    !!document.querySelector('.nav-list .menu-item-has-children.is-open');
  const currencyIsOpen = () =>
    !!trigger && trigger.getAttribute('aria-expanded') === 'true';

  function sync() {
    const currency = currencyIsOpen();

    // Never clear the flag out from under one of the nav's own dropdowns: they
    // share it, and this control closing does not mean Community has.
    setNavDropdownOpen(currency || navDropdownIsOpen() || pointerInside);

    // Tell the veil how far down it has to reach, the same sum
    // setNavVeilReach() uses for a sub-menu.
    if (currency && panel && item) {
      const reach = REVEAL_OFFSET + item.offsetTop + panel.offsetTop + panel.offsetHeight;
      document.documentElement.style.setProperty('--nav-veil-reach', `${reach}px`);
    } else if (!navDropdownIsOpen()) {
      document.documentElement.style.removeProperty('--nav-veil-reach');
    }
  }

  nav.addEventListener('pointerenter', () => { pointerInside = true; sync(); });
  nav.addEventListener('pointerleave', () => { pointerInside = false; sync(); });

  if (trigger) {
    new MutationObserver(sync).observe(trigger, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
  }

  sync();
})();
